import React from 'react'

const EditIcon = props => (
    <svg {...props} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.294067 9.23512V7.56453C0.294067 7.44689 0.364656 7.32924 0.435244 7.23512L5.56466 2.12924V2.10571H5.58819L7.23524 0.435122C7.42348 0.246886 7.72936 0.246886 7.89407 0.435122L9.56466 2.10571C9.75289 2.29395 9.75289 2.59983 9.56466 2.76453L7.9176 4.43512H7.89407V4.45865L2.76466 9.56453C2.67054 9.65865 2.55289 9.70571 2.43524 9.70571H0.764656C0.505832 9.70571 0.294067 9.49395 0.294067 9.23512ZM6.57642 2.43512L7.56466 3.44689L8.57642 2.43512L7.56466 1.44689L6.57642 2.43512ZM6.90583 4.10571L5.89407 3.11747L1.23524 7.7763V8.76453H2.24701L6.90583 4.10571Z" fill="#CACFD5"/>
    </svg>
)

export default EditIcon